const DEFAULT_HOST = "https://api.neufville.family"

export function apiStrings() {
    return fetch(`${DEFAULT_HOST}/strings`).then(res => res.json());
}

export function apiCreateUser(email, fullname, password) {
    return fetch(`${DEFAULT_HOST}/create-user`, {
        method: 'POST',
        body: JSON.stringify({
            email,
            fullname,
            password,
        }),
        headers: {
            'Content-Type': 'application/json',
        },
    });
}

export function apiConfirmUser(clientId, username, confirmationCode) {
    return fetch(`${DEFAULT_HOST}/confirm-user`, {
        method: 'POST',
        body: JSON.stringify({
            clientId,
            username,
            confirmationCode,
        }),
        headers: {
            'Content-Type': 'application/json',
        },
    });
}

export function apiLogin(email, password) {
    return fetch(`${DEFAULT_HOST}/login`, {
        method: 'POST',
        credentials: 'include',
        body: JSON.stringify({
            email,
            password,
        }),
        headers: {
            'Content-Type': 'application/json',
        },
    });
}

export function apiLogout() {
    return fetch(`${DEFAULT_HOST}/logout`, {
        method: 'POST',
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            'AccessToken': localStorage.getItem('access_token'),
        }
    });
}

export async function apiIsLoggedIn() {
    return fetch(`${DEFAULT_HOST}/is-logged-in`, {
        method: 'GET',
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            'AccessToken': localStorage.getItem('access_token'),
        }
    }).then(res => {
        if (res.ok) {
            if (res.headers.get('AccessToken')) {
                localStorage.setItem('access_token', res.headers.get('AccessToken'));
            }
            return true;
        }
        return false;
    }).catch(error => {
        console.error('Error checking login status:', error);
        return false;
    });
}

export function apiGetContactList() {
    return fetch(`${DEFAULT_HOST}/contact-list`, {
        method: 'GET',
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            'AccessToken': localStorage.getItem('access_token'),
        }
    });
}

export function apiGetReunionList() {
    return fetch(`${DEFAULT_HOST}/reunions`, {
        method: 'GET',
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            'AccessToken': localStorage.getItem('access_token'),
        }
    });
}
